import { ReactElement, useCallback } from 'react';
import { createFetchContext } from '../../../../../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../../../../../components/Info/DisplayError';
import Loading from '../../../../../../../../components/Info/Loading';
import { getCurriculumProgress } from '../../../../../api/academicHistoryRequests';
import { CurriculumProgressBase } from '../types/progress';

export interface CurriculumLoaderProps<T> {
  studyPlanEnrollmentId: string;
  children: (props: { data: T }) => ReactElement;
}

const { FetchProvider, FetchConsumer } = createFetchContext<
  { studyPlanEnrollmentId: string },
  CurriculumProgressBase
>();

export const CurriculumLoaderConsumer = FetchConsumer;

export function CurriculumLoader({
  studyPlanEnrollmentId,
  children,
}: CurriculumLoaderProps<CurriculumProgressBase>) {
  const request = useCallback(() => {
    return getCurriculumProgress(studyPlanEnrollmentId);
  }, [studyPlanEnrollmentId]);
  return (
    <FetchProvider
      request={request}
      defaultQuery={{ studyPlanEnrollmentId }}
      fetchImmediately
    >
      <FetchConsumer>
        {({ data, loading, error, refresh }) => {
          if (error) {
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          if (loading) {
            return (
              <div className="mx-3">
                <Loading insideCard />
              </div>
            );
          }

          if (!data) {
            return (
              <DisplayError
                insideCard
                textBody="Data no cargada"
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          return children({ data });
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
